<script lang="ts">
    import Btn from "../components/Btn.svelte";
    import Container from "../components/Container.svelte";
    import Divider from "../components/Divider.svelte";
    import Dropdown from "../components/Dropdown.svelte";
    import Gap from "../components/Gap.svelte";
    import Headline from "../components/Headline.svelte";
    import Hero from "../components/Hero.svelte";
    import IconImg from "../components/IconImg.svelte";
    import Image from "../components/Image.svelte";
    import LightTheme from "../components/LightTheme.svelte";
    import PageTransition from "../components/PageTransition.svelte";
    import Row from "../components/Row.svelte";
    import Subline from "../components/Subline.svelte";
    import { t } from "../helpers/translation";
    import MapIcon from "../icons/MapIcon.svelte";
    import type { Job } from "./karriere/[id]/[url].svelte";
    import { JobLocations } from "./karriere/[id]/[url].svelte";

    import { params } from "@roxi/routify";

    type LocationAndJobs = {
        name: string;
        jobs: Job[];
    };

    const loadData = async (): Promise<LocationAndJobs[]> => {
        const jobs: Job[] = await fetch(`/api/jobs`)
            .then((data) => data.json())
            .then((data) => {
                return data;
            })
            .catch((err) => console.error(err));

        const data: LocationAndJobs[] = [];

        // filter jobs for each location
        Object.entries(JobLocations).forEach(([orderid, [id, name]]) => {
            console.log({ id, name });
            data.push({
                name: name,
                jobs: jobs.filter((job) => job.locationid == id),
            });
        });

        return data
            ? Promise.resolve<LocationAndJobs[]>(data)
            : Promise.reject(null);
    };
</script>

<LightTheme />

<!-- <Hero headline="zuverlässig und <br>schnell" small /> -->

<Hero
    small
    slides={[
        {
            work: $t("page.career.hero.slide.1.work"),
            name: $t("page.career.hero.slide.1.name"),
            headline: $t("page.career.hero.slide.1.headline"),
            person_img: $t("page.career.hero.slide.1.img"),
        },
    ]}
/>

<Container>
    <Headline>
        {@html $t("page.career.headline")}
    </Headline>
    <Subline>
        {@html $t("page.career.subline")}
    </Subline>

    <p>
        {@html $t("page.career.p.1")}
    </p>
    <p>
        {@html $t("page.career.p.2")}
    </p>

    <img
        src="https://liveicom.azureedge.net/sinus/img/members/azubisnoshadow.png"
        alt="sinus karriere"
    />

    <Gap height="5vw" />

    <Headline>
        {@html $t("page.career.chances.headline")}
    </Headline>
    <Subline>
        {@html $t("page.career.chances.subline")}
    </Subline>
    <p>
        {@html $t("page.career.chances.p")}
    </p>

    <Gap height="5vw" />

    <Headline>
        {@html $t("page.career.impressions.headline")}
    </Headline>
    <Subline>
        {@html $t("page.career.impressions.subline")}
    </Subline>

    <div class="impressions">
        <ul>
            <li>{@html $t("page.career.impressions.li.1")}</li>
            <li>{@html $t("page.career.impressions.li.2")}</li>
            <li>{@html $t("page.career.impressions.li.3")}</li>
            <li>{@html $t("page.career.impressions.li.4")}</li>
            <li>{@html $t("page.career.impressions.li.5")}</li>
            <li>{@html $t("page.career.impressions.li.6")}</li>
            <li>{@html $t("page.career.impressions.li.7")}</li>
            <li>{@html $t("page.career.impressions.li.8")}</li>
            <li>{@html $t("page.career.impressions.li.9")}</li>
            <li>{@html $t("page.career.impressions.li.10")}</li>
            <li>{@html $t("page.career.impressions.li.11")}</li>
            <li>{@html $t("page.career.impressions.li.12")}</li>
            <li>{@html $t("page.career.impressions.li.13")}</li>
            <li>{@html $t("page.career.impressions.li.14")}</li>
            <li>{@html $t("page.career.impressions.li.15")}</li>
            <li>{@html $t("page.career.impressions.li.16")}</li>
            <li>{@html $t("page.career.impressions.li.17")}</li>
            <li>{@html $t("page.career.impressions.li.18")}</li>
            <!-- <li>{@html $t("page.career.impressions.li.19")}</li> -->
        </ul>
    </div>

    <Gap height="6rem" />

    <div id="job-listings" />
    <Headline>
        {@html $t("page.career.joblistings.headline")}
    </Headline>
    <Gap height="3rem" />

    {#await loadData()}
        Jobs laden...
    {:then locations}
        {#each locations as location}
            <Dropdown
                auto_open={location.jobs.length > 0}
                heading={`${location.name} (${location.jobs.length})`}
            >
                <div class="dropdown-wrapper">
                    {#each location.jobs as job}
                        <Btn arrow href={`karriere/${job.id}/${job.url}`} small
                            >{job.name}</Btn
                        >
                    {:else}
                        In {location.name} bieten wir aktuell keine Stellen an.
                    {/each}
                </div>
            </Dropdown>
            <Gap />
        {/each}
    {:catch}
        Jobs konnten nicht geladen werden.
    {/await}

    <Gap height="6rem" />
    <div class="auszeichnungen">
        <img
            id="top-arbeitgeber"
            src="https://liveicom.azureedge.net/sinus/img/top-arbeitgeber2021.svg"
            alt="sinus ist top arbeitgeber 2021"
        />
        <img
            id="kununu"
            src="https://liveicom.azureedge.net/sinus/img/kununu-Top-Company-2022.png"
            alt=""
        />
        <img
            id="kununu"
            src="https://liveicom.azureedge.net/sinus/img/kununu-Top-Company-2023.png"
            alt=""
        />
        <img
            id="kununu"
            src="https://liveicom.azureedge.net/sinus/img/kununu-Top-Company-2024.png"
            alt=""
        />
        <img
            id="kununu"
            src="https://liveicom.azureedge.net/sinus/img/kununu-Top-Company-2025.png"
            alt=""
        />
    </div>

    <Gap height="10vh" />

    <div id="contact-cta">
        <div>
            <img
                src="https://liveicom.azureedge.net/sinus/img/members/Carmen_Anders_Abteilungsleiterin_Verwaltung_3G9A5790.jpg"
                alt="frau carmen anders"
            />
        </div>
        <div id="contact-details">
            <div>
                <Subline>
                    {@html $t("page.career.ctasection.subline")}
                </Subline>
                <h4>
                    {@html $t("page.career.ctasection.jobtitle")}
                </h4>
                <p>
                    {@html $t("page.career.ctasection.p")}
                </p>
                <p>
                    <a href="tel:+49406828750">+49 40 6828750</a> <br />
                    <a href="mailto:mailto:personal@sinus-nt.de"
                        >personal@sinus-nt.de</a
                    >
                </p>
            </div>
            <Divider gap="1.3rem" width="33%" />
            <div>
                <Btn href="ueber-uns/niederlassungen" yellow arrow>
                    {@html $t("page.career.ctasection.btn.locations")}
                </Btn>
                <Btn href="kontakt" arrow>
                    {@html $t("page.career.ctasection.btn.contact")}
                </Btn>
            </div>
        </div>
    </div>
    <Gap height="10vh" />
</Container>

<style lang="scss">
    @import "../vars";

    #contact-cta {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;

        @media (max-width: 800px) {
            grid-template-columns: 1fr;
        }

        img {
            height: 28rem;
            object-fit: cover;
            object-position: center;
            // transform: scaleX(-1);
            border-radius: 1rem;
        }

        #contact-details {
            display: grid;
            grid-template-columns: 1fr;
            align-content: space-between;
        }
    }

    .impressions {
        ul {
            padding-bottom: 0.66em;
            li {
                font-weight: 600;
            }
        }
        strong {
            padding-bottom: 0.25em;
            display: block;
            font-weight: 600;
            color: $grayDark;
        }
    }

    .auszeichnungen {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 4rem;
        img {
            height: 12rem;
            max-width: 80vw;
            width: auto;
        }
    }
    // #top-arbeitgeber {
    //     display: block;
    //     margin: auto;
    //     width: 100%;
    //     max-width: 200px;
    //     width: clamp(6rem, 40vw, 250px);
    // }

    .dropdown-wrapper {
        display: flex;
        gap: 1em;
        flex-wrap: wrap;
    }
</style>
